var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Funnel stage")]),_c('th',[_vm._v("Number")]),_c('th',[_vm._v("Conversion from previous stage")]),_c('th',[_vm._v("Conversion from top of the funnel")]),_c('th',[_vm._v("Credit volume (USD)")])])])
}]

export { render, staticRenderFns }